import type { RootState } from 'store/wos_store';

export const selectCartOrderOptions = (state: RootState) => state.cart.betterCart?.options;
